// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.dauraMarzen',
  title: 'hardCoded.title.dauraMarzen',
  slug: titleToSlug('hardCoded.title.dauraMarzen'),
  catalog: {
    title: 'hardCoded.catalog.title.dauraMarzen',
    catalogMedia,
    price: numberToCurrency('6.30'),
    color: '#17302a'
  }
}
